import { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './context/AuthContext';
import Landing from './pages/Landing';
import Dashboard from './pages/Dashboard';
import Snap from './pages/Snap';
import History from './pages/History';
import Pricing from './pages/Pricing';
import AuthCallback from './pages/AuthCallback';
import Recipes from './pages/Recipes';
import InstallNudge from './components/InstallNudge';

function AppRouter() {
  const location = useLocation();
  // Capture ?ref=CODE for referral tracking (persist to localStorage until sign-in)
  useEffect(() => {
    const p = new URLSearchParams(location.search);
    const ref = p.get('ref');
    if (ref) {
      try { localStorage.setItem('cs_ref', ref.toUpperCase()); } catch (e) { /* ignore */ }
    }
  }, [location.search]);
  // Synchronous detection of session_id in URL fragment (must happen during render, not useEffect)
  if (location.hash && location.hash.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/app" element={<Dashboard />} />
      <Route path="/app/snap" element={<Snap />} />
      <Route path="/app/history" element={<History />} />
      <Route path="/app/recipes" element={<Recipes />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <InstallNudge />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
